import WebComponentContainer from '../generic/WebComponentContainer'
import React, { useState } from 'react'
import useEventBus from '../generic/useEventBus'
import { LoadingPageNumber, VehiclePageNumber } from '../../constants'
import { BrowserUtils, QuestionUtils } from '../../utils/siteUtils'

export default props => {
  const {
    certificatePageIsLoaded,
    updateGlobalState,
    offerId,
    utmSource,
    isAdmin,
    offerCode,
    nextClick,
    offer,
    urlState,
    updateVehiclePropNumber,
    canEditMileageIneligible,
    minimumMileageIneligibleThreshold,
    qxData,
    prospectId,
    dealerName,
    dealerIsDirectToKBB,
    theme,
  } = props
  const [showLoader, setShowLoader] = useState(true)
  useEventBus('OfferFetchSuccess', offer => {
    if (offer && offer.offerId) {
      const offerCertificate = {
        offerCertificate: {
          offerId: offer.offerId,
          amount: offer.amount,
          status: offer.status,
          expirationDate: offer.expirationDate,
          offerCode: offer.offerCode,
          markupAmounts: offer.markupAmounts,
          totalOfferAmounts: offer.totalOfferAmounts,
          zip: offer.zip,
        }
      }

      BrowserUtils.postMessage(JSON.stringify(offerCertificate), '*')
    }

    setShowLoader(false)
  })

  useEventBus('ExternalTradeCompleted', event => {
    BrowserUtils.clearLastPostMessage()
    const payload = {
      type: event.type,
      payload: event.payload
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  })

  useEventBus('ExternalTradeError', event => {
    BrowserUtils.clearLastPostMessage()
    BrowserUtils.postMessage(JSON.stringify(event), '*')
  })

  useEventBus('OfferResubmit', ({ mileage, editMileageIneligibleOffer }) => {
    urlState['m'] = mileage
    if (editMileageIneligibleOffer) {
      const item = QuestionUtils.getMileageEligibleOfferQuestion(mileage)
      if (qxData && !qxData.find(question => question.questionId === item.questionId)) qxData.push(item)
    }
    updateVehiclePropNumber('mileage', mileage)
    updateGlobalState({
      firstName: offer?.prospect?.contactInfo.firstName,
      lastName: offer?.prospect?.contactInfo.lastName,
      email: offer?.prospect?.contactInfo.email,
      phone: offer?.prospect?.contactInfo.phone,
      zip: offer?.prospect?.contactInfo.zip,
      termsAccepted: true
    })
    nextClick(LoadingPageNumber)
  })

  useEventBus('onUpdateOfferInfo', ({ year, make, model, mileage }) => {
    urlState['m'] = mileage
    setTimeout(function () {
      BrowserUtils.navigateWithUrlState({ year, make, model, updateState: { p: VehiclePageNumber, lp: VehiclePageNumber, m: mileage } })
    })
  })

  useEventBus('TrackingEvent', event => {
    const dealer = event?.eventData?.dealer
    if (dealer) {
      updateGlobalState({ certificateInfo: { dealer } })
    }
  })

  return (
    <WebComponentContainer pageLoadingComplete={certificatePageIsLoaded} withLoader={showLoader} location={'certificate'} theme={theme}>
      <ico-certificate-hydrator
        offer-id={offerId}
        utm-source={utmSource}
        is-admin={isAdmin}
        offer-code={offerCode}
        can-edit-mileage-ineligible={canEditMileageIneligible}
        minimum-mileage-ineligible-threshold={minimumMileageIneligibleThreshold}
        prospect-id={prospectId}
        dealer-name={dealerName}
        show-kelley-buys-your-car={dealerIsDirectToKBB}
        theme={theme}>
        <offer-certificate></offer-certificate>
      </ico-certificate-hydrator>
    </WebComponentContainer>
  )
}
